module.exports = __webpack_public_path__ + "static/splash_header-ffcdfcc4148987ea8fe55a8a4e966d9e.jpg";